import { convertMarkupHtmlToString } from 'shared/entities/markup';

import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../../block/common';

import {
  ActionNotifyManagersNormalizer,
  IActionNotifyManagersParams
} from './client';

const createActionNotifyManagersActualNameBase = (text: string): string => {
  return text;
};

export const createActionNotifyManagersActualName: ActualNameCreator<
  IActionNotifyManagersParams
> = ({ params }) =>
  createActionNotifyManagersActualNameBase(params.markup.plainText);

export const normalizeActionNotifyManagers: ActionNotifyManagersNormalizer = (
  raw,
  stores
) => {
  const text = convertMarkupHtmlToString(raw.params.markup);

  return {
    ...normalizeCommonFields(raw, stores),
    actualName: (t) =>
      createActualBlockName({
        paramsName: createActionNotifyManagersActualNameBase(text),
        blockKind: raw.kind,
        blockName: raw.name,
        t,
        ...stores
      })
  };
};
